import {Component, Inject, OnDestroy, OnInit, Optional} from '@angular/core';
import {ConfigureWidgetTextComponent} from '../../add-widget-dialog/configure-widget-text/configure-widget-text.component';
import {ComponentType} from '@angular/cdk/overlay';
import {DashboardWidget} from '../../../../../shared/store/report/report-dashboard';
import {ReportDashboardWidgetStore} from '../../../../../shared/store/report/report-dashboard-widget.store';

@Component({
  selector: 'app-widget-text',
  templateUrl: './widget-text.component.html',
  styleUrls: ['./widget-text.component.scss']
})
export class WidgetTextComponent implements OnInit, OnDestroy {
  public readonly settingsDialog:   ComponentType<ConfigureWidgetTextComponent> = ConfigureWidgetTextComponent;

  constructor(
    @Optional() @Inject('widget') public readonly widget: DashboardWidget,
    private readonly _reportDashboardWidgetStore: ReportDashboardWidgetStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

}
